// extracted by mini-css-extract-plugin
export var container = "_c8-1";
export var cornerButtonContainer = "_c8-6";
export var disabled = "_c8-2";
export var dragActive = "_c8-3";
export var fileContainer = "_c8-5";
export var hiddenInput = "_c8-4";
export var widthContainer = "_c8-0";